var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import moment from 'moment-timezone';
import { useCallback } from 'react';
import { flowsApi } from 'apis/flows';
import { analytics } from 'app/utils/segment';
import { notificationActions } from 'components/notifications/actions/notification';
import { useAppDispatch } from 'utils/redux/useAppDispatch';
import { useAppNavigate } from 'utils/url/useAppNavigate';
import { userHasRole } from 'utils/user/userHasRole';
/**
 * Returns a callback to check whether there are conflicting dates within the
 * created schedules, and notifies the user if they have admin role.
 */
export const useScheduleConflictsNotice = () => {
    const dispatch = useAppDispatch();
    const navigate = useAppNavigate();
    return useCallback((user) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b;
        if (!userHasRole(user, 'admin'))
            return;
        const lsKey = 'scheduleConflictsTimestamp';
        try {
            const { data: response } = yield dispatch(flowsApi.endpoints.readFlowsSchedulesConflicts.initiate());
            const conflictingSchedules = (_a = response === null || response === void 0 ? void 0 : response.data.schedules_in_conflicts) !== null && _a !== void 0 ? _a : [];
            const { length: conflictsLength } = conflictingSchedules;
            const localConflictsTimestamp = (_b = localStorage.getItem(lsKey)) !== null && _b !== void 0 ? _b : '';
            if (!conflictsLength) {
                if (!localConflictsTimestamp) {
                    localStorage.removeItem(lsKey);
                }
                return;
            }
            const { notificationAdd, notificationRemoveByType } = notificationActions;
            if (!localConflictsTimestamp ||
                moment.utc().isAfter(moment.utc(localConflictsTimestamp))) {
                const handleNotificationAction = (isClosed) => () => {
                    localStorage.setItem(lsKey, moment.utc().add(1, 'days').toISOString());
                    dispatch(notificationRemoveByType({ type: lsKey }));
                    if (isClosed) {
                        analytics.businessHoursConflictNotificationClosed();
                    }
                    else {
                        analytics.businessHoursConflictNotificationButtonClicked();
                        navigate({
                            path: '/settings/businesshours',
                        });
                    }
                };
                dispatch(notificationAdd({
                    icon: 'exclamation',
                    status: 'warning',
                    leftAction: null,
                    rightAction: {
                        text: 'Go to Business hours',
                        action: handleNotificationAction(),
                    },
                    closeAction: handleNotificationAction(true),
                    title: 'Please review conflicting dates',
                    text: `We found date conflicts in ${conflictsLength} ${conflictsLength === 1 ? 'schedule' : 'schedules'}. For each schedule, please resolve the conflicts.`,
                    type: lsKey,
                }));
            }
        }
        catch (_c) {
            throw new Error('An error occurred when fetching schedule conflicts!');
        }
    }), [navigate, dispatch]);
};
